// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"41571657","513":"f34d7c6e","703":"1b988cac","787":"377c173f"}[chunkId] + ".chunk.js";
};